<template>
    <v-row>
        <oss-dialog v-model="dialog" :title="'Ajouter un mail'" :minWidth="'800px'">
            <v-window v-model="windowStep" touchless>
                <v-window-item :value="'default'">
                    <v-row
                        class="d-flex align-center justify-center"
                        no-gutters
                        v-if="type === 'sendingMail'"
                    >
                        <v-col class="d-flex justify-center">
                            <p>
                                Les adresses Gmail ne sont pas prises en charge, mais arrivent
                                bientôt sur bobbee
                            </p>
                        </v-col>
                    </v-row>
                    <v-container fluid grid-list-md>
                        <v-list subheader>
                            <v-list-item
                                class="mb-2"
                                @click="
                                    connectToAccountingMail();
                                    type = '';
                                "
                                v-if="type == 'accountingMail'"
                            >
                                <v-list-item-title>Gmail</v-list-item-title>
                                <template v-slot:append class="my-0">
                                    <v-btn-next />
                                </template>
                            </v-list-item>
                            <v-list-item
                                class="mb-2"
                                @click="
                                    connectToDocumentFromMail();
                                    type = '';
                                "
                                v-else-if="type == 'documentFromMail'"
                            >
                                <v-list-item-title>Gmail</v-list-item-title>

                                <template v-slot:append class="my-0">
                                    <v-btn-next />
                                </template>
                            </v-list-item>
                            <v-list-item
                                class="oss-list-item mb-2"
                                @click="windowStep = 'notGmailVue'"
                            >
                                <v-list-item-title>Autre messagerie</v-list-item-title>

                                <template v-slot:append class="my-0">
                                    <v-btn-next />
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-container>
                </v-window-item>
                <v-window-item :value="'notGmailVue'">
                    <v-row
                        class="d-flex align-center justify-center"
                        no-gutters
                        v-if="type === 'sendingMail'"
                    >
                        <v-col class="d-flex justify-center">
                            <p>
                                Les adresses Gmail ne sont pas prises en charge, mais arrivent
                                bientôt sur bobbee
                            </p>
                        </v-col>
                    </v-row>
                    <v-card class="default_card large mx-0 pa-2" elevation="0">
                        <v-form ref="form" v-model="valid">
                            <v-row align="center" no-gutters>
                                <v-col class="d-flex pr-1" cols="12" sm="7">
                                    <v-text-field-filled
                                        v-model="email"
                                        type="text"
                                        label="Email"
                                        required
                                        :rules="[rules.isEmail, rules.notAlreadyUsedMail]"
                                        outlined
                                        @change="adaptHostToEmail()"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col class="d-flex pr-1" cols="12" sm="5">
                                    <v-combobox-filled
                                        v-model="host"
                                        :items="
                                            type === 'sendingMail' ? listHostsSmtp : listHostsImap
                                        "
                                        :label="
                                            type === 'sendingMail' ? 'Serveur SMTP' : 'Serveur IMAP'
                                        "
                                        required
                                        :rules="[rules.notEmpty]"
                                        :disabled="hostDisabled"
                                        outlined
                                        dense
                                    />
                                    <v-btn-icon
                                        icon="$oss-edit"
                                        @click="hostDisabled = !hostDisabled"
                                    />
                                </v-col>
                            </v-row>
                            <v-row align="center" no-gutters>
                                <v-col class="d-flex pr-1" cols="12" sm="7">
                                    <v-text-field-filled
                                        v-model="password"
                                        append-inner-icon="$oss-eye"
                                        :type="show ? 'text' : 'password'"
                                        label="Mot de Passe"
                                        required
                                        :rules="[rules.notEmpty]"
                                        outlined
                                        density="compact"
                                        @click:append-inner="show = !show"
                                    />
                                </v-col>
                                <v-col class="d-flex pr-1" cols="12" sm="5">
                                    <v-text-field-filled
                                        v-model="port"
                                        type="text"
                                        label="Port"
                                        required
                                        :rules="[rules.notEmpty]"
                                        :disabled="portDisabled"
                                        outlined
                                        density="compact"
                                    />
                                    <v-btn-icon
                                        icon="$oss-edit"
                                        @click="portDisabled = !portDisabled"
                                    />
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-alert type="error" :model-value="errorCredentials"
                            >Adresse mail, mot de passe ou serveur IMAP incorrect
                        </v-alert>
                        <v-alert type="error" :model-value="errorCredentials2"
                            >Adresse mail incorrecte
                        </v-alert>
                    </v-card>
                </v-window-item>
            </v-window>

            <template v-slot:actions>
                <v-row no-gutters v-if="windowStep !== 'default'">
                    <v-col cols="12" class="pr-2">
                        <v-btn-primary
                            v-if="!loading"
                            rounded
                            block
                            :disabled="!valid"
                            @click="testAndCreation(type)"
                            size="x-large"
                            >Ajouter</v-btn-primary
                        >
                        <v-btn-primary v-else rounded block icon size="x-large">
                            <v-progress-circular
                                :size="40"
                                :width="7"
                                color="white"
                                indeterminate
                                style="margin: 24px"
                            />
                        </v-btn-primary>
                    </v-col>
                </v-row>
            </template>
        </oss-dialog>
    </v-row>
</template>

<script lang="ts">
import { AccountingConfigAPIBase } from "./AccountingConfigAPIBase";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class AccountingConfigAPI extends AccountingConfigAPIBase {}

export default toNative(AccountingConfigAPI);
</script>
